export default () => {
  return {
    clinicDataFields: [],
    clinicDataFieldSections: [],
  };
};
